/**
 * Is it the first child of the parent
 */
export const isFirstChild = path => path[path.length - 1] === 0;
